// components
import CommonForm from "../Common/CommonForm";
import BaseApi from "../../utils/BaseApi";
import CommonActionModal from "../Common/CommonActionModal";

// icons
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AssignmentIcon from "@mui/icons-material/Assignment";


class BankTransactionUploadModal extends CommonActionModal {
    async componentDidMount() {
        let formFields = await this.retrieveFields();
        this.setState({
            buttonIcon: AddCircleIcon,
            buttonLabel: 'Добавить',
            buttonColor: 'primary',
            modalLabel: 'Добавление транзакций',
            modalIcon: AssignmentIcon,
            mainComponent: CommonForm,
            mainComponentProps: {
                fields: formFields,
                processForm: this.processForm.bind(this),
            },
            ready: true,
        })
    }

    async retrieveFields() {
        return [
            {
                'name': 'upload',
                'label': 'Файл',
                'xs': 12,
                'sm': null,
                'md': null,
                'lg': null,
                'xl': null,
                'required': true,
                'default': null,
                'type': 'file',
            },
            {
                'name': 'max_row',
                'label': 'До N строки',
                'xs': 12,
                'sm': null,
                'md': null,
                'lg': null,
                'xl': null,
                'required': true,
                'default': 2,
                'type': 'number',
            },
            {
                type: 'submit',
                label: 'Создать'
            }
        ]
    }

    async processForm(form) {
        let formData = form.state.formData;
        let fileInput = form.state.formObject.upload;
        let upload = fileInput.files[0];
        if (upload) {
            formData.append('upload', upload);
        }
        const url = `bank_transaction/upload/`;
        const api = new BaseApi();
        let response = await api.post(
            url,
            formData
        );
        if (response.status === 200) {
            if (this.props.callBack){
                await this.props.callBack()
            }
            this.setModalOpenFalse();
        }
    }
}

export default BankTransactionUploadModal